import React from "react";

const ChatComposer = ({ input, setInput, sending, onKeyDown, onSend }) => {
  return (
    <div className="flex flex-col gap-1 w-full bg-slate-50 border-t border-slate-200 px-3 py-2">
      {sending ? (
        <div className="flex items-center justify-center gap-2 h-10">
          <span className="text-xs font-medium tracking-widest uppercase text-blue-600/70">
            Loading
          </span>
          <div className="flex gap-1">
            <div className="w-2 h-2 rounded-full bg-blue-500 animate-bounce" />
            <div className="w-2 h-2 rounded-full bg-blue-400 animate-bounce delay-150" />
            <div className="w-2 h-2 rounded-full bg-blue-300 animate-bounce delay-300" />
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center w-full">
            <textarea
              className="flex-1 w-full resize-none rounded-full border border-slate-300 px-4 py-2 text-sm outline-none max-h-32 overflow-y-auto focus:ring-2 focus:ring-primaryPurple bg-white text-slate-900 placeholder:text-slate-400"
              placeholder="Type a message…"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={onKeyDown}
              rows={1}
              disabled={sending}
            />
            <button
              className="ml-1 inline-flex items-center justify-center rounded-full w-10 h-10 text-lg bg-slate-900 text-white hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={onSend}
              disabled={!input.trim()}
              title="Send message"
            >
              ➤
            </button>
          </div>

          <p className="text-xs text-slate-500">
            If you need any further clarifications, please reach out to HR.
          </p>
        </>
      )}
    </div>
  );
};

export default ChatComposer;

